export default function Default(colors, presetColor, mode = 'light') {
  const { red, gold, cyan, green, grey } = colors;

  // British Racing Green — cor primária
  // Tons "lighter/main" são pensados para texto/ícone escuro sobre fundo
  // claro; no dark mode o papel se inverte (precisa de verde claro/vivo
  // sobre fundo escuro), então a rampa inteira troca em vez de reaproveitar
  // os mesmos hexadecimais.
  const brg = mode === 'dark'
    ? [
        'rgba(0,168,90,0.12)', // 0  lighter (fill sutil)
        'rgba(0,168,90,0.18)', // 1
        'rgba(0,168,90,0.24)', // 2
        '#3fae7a',             // 3  light
        '#22c55e',             // 4
        '#00a85a',             // 5  main
        '#00c46a',             // 6  dark (hover, mais claro no escuro)
        '#33d17f',             // 7
        '#001609',             // 8  darker
        '#000e06',             // 9
      ]
    : [
        '#e8f5ee', // 0  lighter
        '#c5e5d3', // 1
        '#9acfb5', // 2
        '#6ab894', // 3  light
        '#2d8a5e', // 4
        '#004225', // 5  main
        '#003018', // 6  dark (hover)
        '#00220f', // 7
        '#001609', // 8  darker
        '#000e06', // 9
      ];

  const greyColors = {
    0: grey[0], 50: grey[1], 100: grey[2], 200: grey[3], 300: grey[4],
    400: grey[5], 500: grey[6], 600: grey[7], 700: grey[8], 800: grey[9],
    900: grey[10], A50: grey[15], A100: grey[11], A200: grey[12],
    A400: grey[13], A700: grey[14], A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: brg[0], 100: brg[1], 200: brg[2], light: brg[3],
      400: brg[4], main: brg[5], dark: brg[6], 700: brg[7],
      darker: brg[8], 900: brg[9], contrastText
    },
    secondary: {
      lighter: greyColors[100], 100: greyColors[100], 200: greyColors[200],
      light: greyColors[300], 400: greyColors[400], main: greyColors[500],
      600: greyColors[600], dark: greyColors[700], 800: greyColors[800],
      darker: greyColors[900], A100: greyColors[0], A200: greyColors.A400,
      A300: greyColors.A700, contrastText: greyColors[0]
    },
    error:   { lighter: red[0],  light: red[2],  main: red[4],  dark: red[7],  darker: red[9],  contrastText },
    warning: { lighter: gold[0], light: gold[3], main: gold[5], dark: gold[7], darker: gold[9], contrastText: greyColors[100] },
    info:    { lighter: cyan[0], light: cyan[3], main: cyan[5], dark: cyan[7], darker: cyan[9], contrastText },
    success: { lighter: green[0], light: green[3], main: green[5], dark: green[7], darker: green[9], contrastText },
    grey: greyColors
  };
}
